import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer {
  // Rendered as "© Copyright 2018-<this year>, INKfection Collection".
  readonly year = `2018-${new Date().getFullYear()}`;
}
